// extracted by mini-css-extract-plugin
export default {"modalWrap":"ModalView_modalWrap__CMURe","modalCloseButton":"ModalView_modalCloseButton__o+iE1"};